var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSiren = function SvgSiren(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M2.91 1.694c.107-.88.827-1.52 1.68-1.52h4.665c.853 0 1.6.64 1.706 1.52l.666 5.305H4.643l.56-4.639c.053-.213-.133-.426-.347-.453-.24-.053-.453.133-.48.347l-.613 4.745H2.244zM1.817 7.852h10.237c.453 0 .853.4.853.853v.853c0 .48-.4.853-.853.853H1.817a.84.84 0 0 1-.853-.853v-.853c0-.454.374-.853.853-.853"
  })));
};
export default SvgSiren;